// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__1mgF3","col":"Table_col__1ir45","fulfillmentStatus":"Table_fulfillmentStatus__1xxXL","emailCol":"Table_emailCol__3hK6W"};